/**
 * @generated SignedSource<<443dbd7ae74536d63a3ffcbbbb80355b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreProductExpireBatchActionStatus = "COMPLETED" | "INFO" | "PENDING";
export type ProductExpireBatchSetActionStatusMutation$variables = {
  actionId: string;
  employeeId?: string | null;
  productExpireBatchId: string;
  productId: string;
  status: StoreProductExpireBatchActionStatus;
};
export type ProductExpireBatchSetActionStatusMutation$data = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly setActionStatus: {
        readonly actions: ReadonlyArray<{
          readonly id: string;
          readonly status: StoreProductExpireBatchActionStatus;
        }>;
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type ProductExpireBatchSetActionStatusMutation$rawResponse = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly setActionStatus: {
        readonly actions: ReadonlyArray<{
          readonly id: string;
          readonly status: StoreProductExpireBatchActionStatus;
        }>;
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type ProductExpireBatchSetActionStatusMutation = {
  rawResponse: ProductExpireBatchSetActionStatusMutation$rawResponse;
  response: ProductExpireBatchSetActionStatusMutation$data;
  variables: ProductExpireBatchSetActionStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productExpireBatchId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productId"
      }
    ],
    "concreteType": "StoreProductMutation",
    "kind": "LinkedField",
    "name": "storeProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "productExpireBatchId"
          }
        ],
        "concreteType": "StoreProductExpireBatchMutation",
        "kind": "LinkedField",
        "name": "expireBatch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "employeeId",
                "variableName": "employeeId"
              },
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "actionId"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status"
              }
            ],
            "concreteType": "StoreProductExpireBatch",
            "kind": "LinkedField",
            "name": "setActionStatus",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatchAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductExpireBatchSetActionStatusMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductExpireBatchSetActionStatusMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "a950067584d4ae96ebce896782077f74",
    "id": null,
    "metadata": {},
    "name": "ProductExpireBatchSetActionStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ProductExpireBatchSetActionStatusMutation(\n  $productId: ID!\n  $productExpireBatchId: ID!\n  $actionId: ID!\n  $status: StoreProductExpireBatchActionStatus!\n  $employeeId: ID\n) {\n  storeProduct(id: $productId) {\n    expireBatch(id: $productExpireBatchId) {\n      setActionStatus(id: $actionId, status: $status, employeeId: $employeeId) {\n        id\n        actions {\n          id\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d9eab3f85617084e4bd710810906fd1";

export default node;
